import { onBeforeUnmount } from 'vue'
import { useApi } from '../useApi/useApi'

export const useApiRequestsAbort = () => {
  onBeforeUnmount(() => {
    Object.entries(useApi()).forEach(([_, apiService]) => {
      apiService.abortRequests()
    })
  })
}
